
import Can from './can'

export const RBAC_DISABLED = false

export function canReadWorkspaceMembers () {	
	return Can('view', 'workspace-members') || RBAC_DISABLED
}

export function canManageWorkspaceMembers () {
	return Can('manage', 'workspace-members') || RBAC_DISABLED
}

export function canManageWorkspaceMemberSettings () {
	return Can('manage', 'workspace-member-settings') || RBAC_DISABLED
}

// read or view, as the API's content checks take either (GetContentItem's SecurityVoter); roles give
// members and executives read
export function canReadWorkspaceContent () {
	return Can('view', 'workspace-content') || Can('read', 'workspace-content') || RBAC_DISABLED
}

export function canReadWorkspaceSchedules () {
	return Can('view', 'workspace-schedules') || RBAC_DISABLED
}

export function canReadMySchedules () {
	return Can('view', 'my-schedules') || RBAC_DISABLED
}

export function canReadStackRankReports () {
	return Can('view', 'stack-rank-reports') || RBAC_DISABLED
}

export function canReadIndustrySnapshotReports () {
	return Can('view', 'industry-snapshot-reports') || RBAC_DISABLED
}

export function canReadSmartSearchReports () {
	return Can('view', 'smartsearch-reports') || RBAC_DISABLED
}

export function canReadPeerPerformanceReports () {
	return Can('view', 'peer-performance-reports') || RBAC_DISABLED
}

export function canManageWorkspaceContent () {
	return Can('manage', 'workspace-content') || RBAC_DISABLED
}

export function canViewMyContent () {
	return Can('view', 'my-content') || Can('read', 'my-content') || RBAC_DISABLED
}

export function canManageMyContent () {
	return Can('manage', 'my-content') || RBAC_DISABLED
}

export function canExportWorkspaceContent () {
	return Can('export', 'workspace-content') || RBAC_DISABLED
}

export function canManageProfileApproval () {
	return Can('manage', 'profile-approval') || RBAC_DISABLED
}

export function canReadCampaigns () {
	return Can('view', 'campaigns') || RBAC_DISABLED
}

export function canManageCampaigns () {
	return Can('manage', 'campaigns') || RBAC_DISABLED
}

export function canReadSocialActivities () {
	return Can('view', 'social-activity') || RBAC_DISABLED
}

export function canManageSocialActivities () {
	return Can('manage', 'social-activity') || RBAC_DISABLED
}

export function canPublishComments () {
	return Can('publish', 'own-comments') || RBAC_DISABLED
}

export function canPublishWorkspaceComments () {
	return Can('publish', 'workspace-comments') || RBAC_DISABLED
}

export function canPublishReactions () {
	return Can('publish', 'own-reactions') || RBAC_DISABLED
}

export function canPublishWorkspaceReactions () {
	return Can('publish', 'workspace-reactions') || RBAC_DISABLED
}

export function canPublishReposts () {
	return Can('publish', 'own-reposts') || RBAC_DISABLED
}

export function canPublishWorkspaceReposts () {
	return Can('publish', 'workspace-reposts') || RBAC_DISABLED
}

export function canManageWorkspaceSettings () {
	return Can('manage', 'workspace-settings') || RBAC_DISABLED
}

export function canManageBilling () {
	return Can('manage', 'billing') || RBAC_DISABLED
}

export function canManageFeeds() {
	return Can('manage', 'feeds') || RBAC_DISABLED
}

export function canManageTopics() {
	return Can('manage', 'topics') || RBAC_DISABLED
}

export function canManageTags() {
	return Can('manage', 'tags') || RBAC_DISABLED
}


export function canManageHashTags() {
	return Can('manage', 'tags') || RBAC_DISABLED
}